import { Box, Tabs, TabList, TabPanels, Tab, TabPanel, Icon, HStack, Text } from '@chakra-ui/react'
import { FiUser, FiBarChart2, FiShield } from 'react-icons/fi'
import { useNavigate, useParams } from 'react-router-dom'
import { PageHeader } from '@/components/Common'
import { useAppTranslation } from '@/contexts/LanguageContext'
import ProfileTab from '@/components/Account/ProfileTab'
import UsageTab from '@/components/Account/UsageTab'
import SecurityTab from '@/components/Account/SecurityTab'

const TAB_PATHS = ['', 'usage', 'security'] as const

export default function AccountPage() {
  const { t } = useAppTranslation('common')
  const navigate = useNavigate()
  const { tab } = useParams()

  const tabIndex = tab === 'usage' ? 1 : tab === 'security' ? 2 : 0

  const handleTabChange = (index: number) => {
    navigate(index === 0 ? '/account' : `/account/${TAB_PATHS[index]}`)
  }

  return (
    <Box p={{ base: 4, md: 6 }}>
      <PageHeader
        title={t('account.pageTitle')}
        description={t('account.pageSubtitle')}
      />

      <Tabs index={tabIndex} onChange={handleTabChange} colorScheme="brand" isLazy>
        <TabList>
          <Tab>
            <HStack spacing={2}>
              <Icon as={FiUser} boxSize={4} />
              <Text>{t('account.tabs.profile')}</Text>
            </HStack>
          </Tab>
          <Tab>
            <HStack spacing={2}>
              <Icon as={FiBarChart2} boxSize={4} />
              <Text>{t('account.tabs.usage')}</Text>
            </HStack>
          </Tab>
          <Tab>
            <HStack spacing={2}>
              <Icon as={FiShield} boxSize={4} />
              <Text>{t('account.tabs.security')}</Text>
            </HStack>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel px={0} py={6}>
            <ProfileTab />
          </TabPanel>
          <TabPanel px={0} py={6}>
            <UsageTab />
          </TabPanel>
          <TabPanel px={0} py={6}>
            <SecurityTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
